import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RoundedArrowButton } from '../../components/buttons';
import ServiceCard from '../../components/common/ServiceCard';
import SubInfo from '../../components/common/SubInfo';
import BigCard from '../../components/layout/BigCard';
import { useMediaQuery } from '@mui/material';

const ServicesSection = () => {
  const navigate = useNavigate();
  const isLessThan640 = useMediaQuery('(max-width: 640px)');

  const services = [
    {
      title: 'Web App Development',
      description: 'With expertise in Custom web application development, we deliver custom web applications designed to fulfill the specific requirements of diverse industries.',
      icon: 'webapp_development_icon.svg',
      alt:"Custom web application development LA"
    },
    {
      title: 'Mobile App Development',
      description: 'We build and improve high-quality iOS and Android apps tailored to your business and users. From new builds to fixing, modernizing, and scaling existing apps, our experienced team delivers the right solution.',
      icon: 'mobile_app_development.svg',
      alt:"Top mobile app development company LA"
    },
    {
      title: 'UI/UX',
      description: 'We create human-centered web and mobile experiences with intuitive interfaces, seamless user flows, and thoughtful design that puts your users first.',
      icon: 'uiux_development_icon.svg',
      alt:"Web design & development agency USA"
    },
    {
      title: 'Software Consultation',
      description: 'We diagnose software challenges, provide expert technical guidance, and recommend practical solutions to improve performance, reliability, and long-term maintainability.',
      icon: 'software_development_icon.svg',
      alt:"Software Consulting Services LA"
    },
  ];

  const TopRightElement = (
    <>
      <div className="flex flex-col items-start breaktwo:items-center">
        <SubInfo
          typographyStyles={{ color: '#263238', fontSize: isLessThan640 ? 15 : 17 }}
          containerClasses="mb-5 breaktwo:mt-3">
          {'From diagnosis and bug fixes to design, development, AI, and modernization, Atini Studio provides expert software care under one roof. We meet your software where it is, identify what needs attention, and deliver the right solution for your business. No unnecessary rebuilds. Just the right treatment for your code.'}
        </SubInfo>
        <RoundedArrowButton
          text={'Check My Software'}
          containerClasses="bg-light-black w-72"
          arrowColor="#263238"
          arrowContainerClasses="bg-white"
          typographyStyles={{ color: 'white', fontWeight: 'light' }}
          onClick={() => {
            navigate('/contact-us');
          }}
        />
      </div>
    </>
  );

  const BottomElement = (
    <Grid container columnSpacing={8} rowSpacing={0}>
      {services.map(({ title, description, icon,alt }, index) => (
        <Grid item xs={12} md={6} key={index}>
          <ServiceCard title={title} description={description} icon={icon} alt={alt} />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <BigCard
      roundInfoText={'OUR SERVICES'}
      mainInfoText={`Full potential 
 services we offer`}
      topRightElement={TopRightElement}
      bottomElement={BottomElement}
      containerClasses="bg-yellow"
      bottomContainerClasses="w-11/12 sm:w-9/12"
      id="services"
      spaceTaken={0.75}
    />
  );
};

export default ServicesSection;
